
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import stores from '../../stores';
import StreamModule from '../../stores/modules/Streams';

@Component({
  components: {},
})

export default class DeleteRecorder extends Vue {
  @Prop()
    module!: StreamModule;
  /**
   * Fired when this module is created
   */
  created() {
    this.delete();
  }

  delete() {
    return this.module.deleteStream(Number(this.$route.params.id))
      .then(() => {
        this.$router.push({name: `transcoder.streams`, params: {moduleId: String(this.module.id)}});
      })
      .catch((reason) => {
        console.error('Could not delete', reason);
      });
  }
}
